import H from '@here/maps-api-for-javascript'
import { useEffect } from 'react'

/**
 * useLine is a low-level hook that puts a line on the map.
 * @param map The HERE map instance.
 * @param from The start point of the line.
 * @param to The end point of the line.
 * @param color The color of the line.
 */
export const useLine = ({
  map,
  from,
  to,
  lineDash,
  lineWidth,
  color,
}: {
  map?: H.Map
  from?: H.geo.IPoint
  to?: H.geo.IPoint
  lineDash?: number[]
  lineWidth?: number
  color: string
}) => {
  useEffect(() => {
    if (map && from && to) {
      const lineString = new H.geo.LineString()

      lineString.pushPoint(from)
      lineString.pushPoint(to)

      const line = new H.map.Polyline(lineString, {
        style: {
          strokeColor: color,
          lineCap: 'round',
          lineDash: lineDash ?? [2, 6],
          lineWidth: lineWidth ?? 2,
        },
        data: {},
      })
      map.addObject(line)

      return () => {
        map.removeObject(line)
      }
    }
    return
  }, [map, from, to, lineDash, lineWidth, color])
}
